<template>
	<div v-if="table && table.body" class="element el-table" :class="{ 'has-error' : table.error,'can-change': is_editable, [variant]: variant, condensed }">
		<table class="table" :style="{ width: width }">
			<thead v-if="table.head">
				<el-row v-for="(row, i) in table.head" :row="row" :config="table.config" :index="i" type="head" :key="'row-' + i" />
			</thead>
			<tbody>
				<el-row :icon="variant === 'tags' && 'tag'" v-for="(row, i) in table.body" :row="row" :config="table.config" :index="i" type="body" :key="'row-' + i" :component="component" @changed_value="changed_value($event, i)" :condensed="condensed" />
			</tbody>
		</table>
		
		<!-- Display error div -->
		<div v-if="is_edit_mode && table && table.error" class="error-container edit-error">
			<div class='content-error'>{{table.error_message}}</div>
		</div>
		<div v-if="!is_edit_mode && table && table.error" class="error-container read-error">
			<div class='content-error'>{{table.error_message}}</div>
		</div>

		<div v-if="lines" class="box-edit" :class="linesBoxClass" v-show="editor.mode == 'editing'">
            <div class="box-edit-line">
              <label>Nombre de lignes</label>
              <input
                type="range"
                v-model="lines"
                min="1"
                :max="nbLinesMax"
                step="1"
              />
            <span class="value">{{ lines }} lignes</span>
			<slot name="edition"/>
            </div>
        </div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import ElementMixin from "@/components/study/editor/elements/element.mixin.js";
import ElRow from "@/components/study/editor/elements/el-table/el-row";

export default {
	name: "el-table",
	mixins: [ ElementMixin ],
	data: function () {
		return {
			
		};
	},
	props: {
		table: { default: function () { return []; } },
		width: { default: "100%" },
		component: { default: undefined },
		variant: {
			type: String,
			default: "default"
		},
		condensed: {
			type: Boolean,
			default: false
		},
		linesObj: {
			type: Object
		},
		linesField: {
			type: String
		},
		linesBoxClass: {
			type: String,
			default: ""
		},
		nbLinesMax: {
			type: String,
			default: "9"
		}
	},
	methods: {
		changed_value: function (event, i) {
			this.$emit("changed_value", {...event, line: i});
		}
	},
	computed: {
		...mapGetters(["editor"]),
		is_edit_mode: function (){
			const result = this.editor.mode == "editing";
			return result;
		},
		lines: {
			get () {
				if(!this.linesObj || !this.linesField) {
					return false;
				}

				const lines = this.linesObj[this.linesField];

				if(lines) {
					return parseInt(lines);
				}

				return false;
			},
			set (value) {
				if(!this.linesObj || !this.linesField) {
					return;
				}

				this.$store.dispatch("edit_object", {
					obj: this.linesObj,
					field: this.linesField,
					value: parseInt(value),
				});
			},
		},
	},
	components: { ElRow }
};
</script>

<style lang="stylus" scoped>
@import '../../../../assets/css/app'
@import '../../../../assets/css/page'

.has-error
	//color red

.error-container
	z-index: 20000
	position absolute
	top 0
	left 0
	width 101% !important
	height 100% !important
	text-align center
	border-style solid
	border-width 2px
	.content-error
		position relative
		top 50%
		transform translateY(-50%)


.edit-error
	opacity 0.8
	background-color black
	color red
	border-color red

.read-error
	opacity 1
	background-color white
	color #3e5d58
	border-color #3e5d58

.el-table
	display block
	.table
		line-height 1.2
		border-collapse collapse
		width 100%
		font-size 10px
		tbody
			border 1px solid main_color

	&.highlight-results
		.table::v-deep
			td
				padding 8px
				font-weight bold
			tbody
				tr
					&:last-child
						background orange
						
						&, td:first-child
							color #fff
	
	&.bordered
		.table::v-deep
			td
				padding 8px
				font-weight bold
			thead
				td:not(:empty)
					border 1px solid #273b37
				td:empty
					border none
			tbody
				td
					border 1px solid #5e857e

	&.tags
		.table
			border-collapse separate
			border-spacing 0 4px

			tbody
				border none

			&::v-deep
				.el-textarea
					float none
					display inline-block

				td
					background #eee
					color dark
					font-weight bold
					margin 5px 0
					padding 10px 4px

					&:first-child
						border-radius 3px 0 0 3px

					&:last-child
						position relative
						background green
						color #fff
						font-weight bold
						border-radius 0 3px 3px 0
						text-align right
						padding-left 15px

						&::before
							content ""
							position absolute
							left -1px
							top 0
							bottom 0
							width 10px
							background: no-repeat center/100% 100%;
							background-image: url("data:image/svg+xml,%0A%3Csvg width='22px' height='84px' viewBox='0 0 22 84' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cpolygon id='Path-2' fill='%23EEEEEE' points='0.5546875 -0.046875 21.5390625 40.953125 0.5546875 83.1780502'%3E%3C/polygon%3E%3C/g%3E%3C/svg%3E");

</style>
